import http from './http'

let query = function (url, success, error) {
  http.fetchGet(url).then((res) => {
    success(res.data.data || res.data || res)
  }).catch((err) => {
    console.log('err', err)
    error()
  })
}

export default {
  install (Vue) {
    let $cloud = {
      query
    }
    Vue.prototype.$cloud = $cloud
  }
}
